import React, { useEffect, useState } from "react"
import styles from "./blog-content.module.css";
import { BlogListRow } from "../BlogListRow/blog-list-row";

const BlogsContent = ({ blogs }) => {
    return (
        <div className="content clear" >
            <div className="articles">
                {
                    blogs.map((blog) => (
                        <BlogListRow data={blog} key={blog.node.id} />
                    ))
                }
            </div>
        </div>
    )
}

export default BlogsContent;
